import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmbroideredComponent } from './embroidered.component';

const routes: Routes = [
  { path: '', component: EmbroideredComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmbroideredRoutingModule { }
